import React from 'react';
import AudioButton from '../components/AudioButton';

const PersianLiteratureDemo: React.FC = () => {
  const persianText = "من دانشجوی ادبیات فارسی هستم و علاقه‌مند به شعر کلاسیک ایران";
  const englishTranslation = "I am a Persian literature student and interested in classical Persian poetry.";
  const audioUrl = "/audio/persian-literature/persian-literature-student.mp3";

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-4">
          Persian Literature Audio Demo
        </h1>
        <p className="text-gray-600 dark:text-gray-300">
          Experience the beauty of Persian language with high-quality audio generation
        </p>
      </div>

      <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-8 mb-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">
            Persian Text
          </h2>
          <AudioButton
            audioUrl={audioUrl}
            text={persianText}
            size="lg"
            variant="primary"
            onPlayStart={() => console.log('Audio playback started')}
            onPlayEnd={() => console.log('Audio playback ended')}
            onError={(error) => console.error('Audio error:', error)}
          />
        </div>
        
        <div className="persian-text text-2xl font-medium text-gray-800 dark:text-white leading-relaxed text-right mb-6 p-6 bg-white dark:bg-gray-700 rounded-lg border-r-4 border-purple-500">
          {persianText}
        </div>
        
        <div className="translation text-lg text-gray-600 dark:text-gray-300 italic text-center">
          "{englishTranslation}"
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-6">
          <h3 className="text-xl font-semibold text-blue-800 dark:text-blue-200 mb-4">
            Audio Information
          </h3>
          <div className="space-y-2 text-sm text-blue-700 dark:text-blue-300">
            <p><strong>Model:</strong> ganji-adabi</p>
            <p><strong>Format:</strong> MP3</p>
            <p><strong>Quality:</strong> High-quality Persian TTS</p>
            <p><strong>Generated:</strong> {new Date().toLocaleDateString()}</p>
          </div>
        </div>

        <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-6">
          <h3 className="text-xl font-semibold text-green-800 dark:text-green-200 mb-4">
            Features
          </h3>
          <ul className="space-y-2 text-sm text-green-700 dark:text-green-300">
            <li>✓ Natural Persian pronunciation</li>
            <li>✓ Classical poetry support</li>
            <li>✓ High-quality audio generation</li>
            <li>✓ Responsive audio controls</li>
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center">
        <p className="text-gray-500 dark:text-gray-400 text-sm">
          This audio was generated using the ganji-adabi Persian TTS model, 
          specifically designed for Persian literature and classical poetry.
        </p>
      </div>
    </div>
  );
};

export default PersianLiteratureDemo;

